import SplitTextCard from './SplitTextCard'


export default SplitTextCard
